import { diContainer, serviceNames } from '../diContainer/diContainer';
import SaveNewBillingAddressUseCase from './SaveNewBillingAddressUseCase';
import BillingRepository from '../repositories/BillingRepository';
import SubmitNewsletterUseCase from './SubmitNewsletterUseCase';
import { BILLING_FORM_ERROR, BILLING_FORM_ERROR_SELECTED } from './ValidateAndSubmitAddressesUseCase';
import TransactionLoadHandler from './TransactionLoadHandler';
import Config from '../domain/entities/Config';
import AddressFormStore from '../domain/entities/AddressFormStore';
import { IAddressSchema } from '../api/JsonSchemaApi';

class SubmitConvenienceStoreUseCase extends TransactionLoadHandler {
  private billingRepository: BillingRepository;

  private config: Config;

  constructor() {
    super();
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
    this.config = diContainer.get(serviceNames.config);
  }

  public async run(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();
    const { billingAddress, convenienceStore } = transaction;
    if (!convenienceStore.isReady) {
      return;
    }

    if (billingAddress.isNewAddress) {
      if (!this.billingRepository.formStore.isValid) {
        this.billingRepository.formStore.setShowErrors(true);
        throw new Error(BILLING_FORM_ERROR);
      }

      const saveNewBillingAddressUseCase = new SaveNewBillingAddressUseCase();
      await saveNewBillingAddressUseCase.execute();

    } else {
      // validate selected billing address
      const validationSchema = {
        properties: this.config.billingAddressInputSchema,
        required: [],
      } as IAddressSchema;

      const isBillingAddressValid = new AddressFormStore(this.config)
        .setAddress(billingAddress)
        .validateAddressBySchema(validationSchema);

      if (!isBillingAddressValid) {
        throw new Error(BILLING_FORM_ERROR_SELECTED);
      }
    }

    const submitNewsletterUseCase = new SubmitNewsletterUseCase();
    await submitNewsletterUseCase.execute();
  }
}

export default SubmitConvenienceStoreUseCase;
